import { useQuery } from 'react-query';
import { buildEndpoint } from '../endpoints';
import { apifetch } from '../robotapi';

export interface GetLinkSavingsRetirementRequest {
    paymentSingleAmount: number;
    paymentRecurringAmount: number;
    paymentRecurringInterval: string;
    paymentRecurringEndDate: string;
    monthOfPayment: number;
    investmentEndDate: string;
}

type GetLinkSavingsRetirementResponse = string;

const getLinkSavingsRetirementUrl = buildEndpoint(['products', 'savingsretirement', 'links']);

const getLinkSavingsRetirementApiCall = (body: GetLinkSavingsRetirementRequest) =>
    apifetch<GetLinkSavingsRetirementResponse, GetLinkSavingsRetirementRequest>(getLinkSavingsRetirementUrl, 'POST')(body);

export const useGetLinkSavingsRetirement = (body: GetLinkSavingsRetirementRequest, enabled: boolean) => {
    const query = useQuery<GetLinkSavingsRetirementResponse>(['savingsretirementlink', body], async () => {
        return getLinkSavingsRetirementApiCall(body);
    },
        { enabled: enabled }
    );

    return query;
};